module.exports = __webpack_public_path__ + "images/signal_3.7130c9270426cc865e3fbf8b586c0ecb.png";